import { useRef } from "react";
import { RichTextarea } from "rich-textarea";
import styles from "./MsgTextArea.module.css";
import { formaters } from "vincent-utils";
import { pad } from "lodash";

interface MsgTextAreaProps {
  id: string;
  name: string;
  firstName: string;
  placeholder?: string;
  className?: string;
  border?: string;
  onSelect: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
  onSubmit: () => void;
  value: string;
}

const MsgTextArea = (props: MsgTextAreaProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const handleSetValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(e.target.value);
  };
  const findConsecutiveCaps = (str: string, lookup: string) => {
    return str.split("").reduce((acc, curr) => {
      if (
        curr === curr.toUpperCase() &&
        lookup.includes(curr.toLocaleLowerCase())
      ) {
        return acc + curr;
      }
      return "";
    }, "");
  };
  const caps = findConsecutiveCaps(props.value, props.name);

  const autoComplete = props.name.slice(caps.length).toLocaleUpperCase();

  const showAutoComplete = caps.length > 1;

  const handleAcceptAutoComplete = () => {
    const newInputValue =
      props.value +
      autoComplete +
      " " +
      formaters.capitaliseEveryFirstLetter(props.firstName);
    props.onChange(newInputValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !showAutoComplete && !e.shiftKey) {
      e.preventDefault();
      props.onSubmit();
    }
    if (e.key === "Enter" && !showAutoComplete && e.shiftKey) {
      e.preventDefault();
      props.onChange(props.value + "\n");
    }
    if (e.key === "Escape") {
      e.preventDefault();
      inputRef.current?.blur();
      props.onChange("");
      props.onCancel();
    }
    //tab or right arrow
    if (
      (e.key === "Tab" || e.key === "ArrowRight" || e.key === "Enter") &&
      showAutoComplete
    ) {
      e.preventDefault();
      handleAcceptAutoComplete();
      props.onSelect();
    }
  };

  return (
    <RichTextarea
      id={props.id}
      className={props.className}
      placeholder={props.placeholder}
      value={props.value}
      onChange={handleSetValue}
      onKeyDown={handleKeyDown}
      style={{
        backgroundColor: "white",
        outline: "none",
        border: props.border || "none",
        resize: "none",
        width: "100%",
        fontSize: "0.9rem",
        paddingLeft: "0.5rem",
        paddingTop: "0.3rem",
      }}
      ref={inputRef}
      rows={3}
    >
      {(text: string) => (
        <>
          {<span className={styles.text}>{text}</span>}
          {showAutoComplete && (
            <span className={styles.autoComplete}>
              {autoComplete +
                " " +
                formaters.capitaliseEveryFirstLetter(props.firstName)}
            </span>
          )}
        </>
      )}
    </RichTextarea>
  );
};

export default MsgTextArea;
